import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

import messages from '@containers/ProductDetailContainer/messages';

import { FadeWrapper } from './FadeWrapper';
import { Text, Wrapper, SectionTitle, TableWrapper, TopMargin } from './styled';
import { renderValueCell } from './utils';
import { VitaminsTable } from './VitaminsTable';

interface CompositionProps {
  html: string;
  tablesData?: NonNullable<
    NonNullable<
      GetCatalogProductViewQuery['productDetailByCatalogMasterId']
    >['variants'][number]['documentation']
  >['composition'];
}

export const Composition = ({ html, tablesData }: CompositionProps) => {
  return (
    <Wrapper data-testid="pd-composition-wrapper" id="pd-composition-wrapper">
      <SectionTitle>
        <FormattedMessage {...messages.fullComposition} />
      </SectionTitle>

      <Text
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />

      {!!tablesData?.nutritionValues?.length && (
        <TopMargin>
          <FadeWrapper>
            <TableWrapper data-testid="nutrition-table">
              <table>
                <tbody>
                  {tablesData.nutritionValues.map((row) => (
                    <tr key={row.nutritionValue}>
                      <td>{row.nutritionValue}</td>
                      <td>
                        {renderValueCell(
                          { ...row, measureUnit: row.measureUnit ?? '' },
                          'amount'
                        )}
                      </td>
                      <td>
                        {renderValueCell(
                          { ...row, measureUnit: row.measureUnit ?? '' },
                          'variantAmount'
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TableWrapper>
          </FadeWrapper>
        </TopMargin>
      )}

      {!!tablesData?.vitaminsAndMinerals?.length &&
        tablesData.vitaminsAndMinerals && (
          <TopMargin>
            <VitaminsTable
              vitaminsAndMinerals={tablesData.vitaminsAndMinerals}
            />
          </TopMargin>
        )}
    </Wrapper>
  );
};
